"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var classes_1 = require("../../classes");
function isValidName() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var properties = arguments.length > 1 ? arguments[1] : undefined;
  if (!name) return new classes_1.ValidationResult(true);
  var safeName = name || "";
  var nameWithoutSpaces = safeName.trim();
  var fullNameArr = nameWithoutSpaces.split(/\s+/);
  // Have at least 2 words in name string
  var minNameCount = 1;
  var isValidNameCount = fullNameArr.length > minNameCount;
  if (!isValidNameCount) return new classes_1.ValidationResult(false);
  // Have any word at least 2 chars, skips char e
  var haveAnyNameAtLeastTwoChar = !fullNameArr.filter(function (partName) {
    return partName.length < 2 && partName !== "e";
  }).length;
  if (!haveAnyNameAtLeastTwoChar) return new classes_1.ValidationResult(false);
  // Dont have any word with starts or ends with a single char
  var haveFirstOrLastWordWithSingleChar = fullNameArr[0].length < 2 || fullNameArr[fullNameArr.length - 1].length < 2;
  if (haveFirstOrLastWordWithSingleChar) return new classes_1.ValidationResult(false);
  // Have any invalid char
  var validCharRegex = /^[a-záéíóúàâêôãõüçñöÁÉÍÓÚÀÂÊÔÃÕÜÇÑÖ][a-z\\'áéíóúàâêôãõüçñöÁÉÍÓÚÀÂÊÔÃÕÜÇÑÖ\s-]+$/gi;
  if (!nameWithoutSpaces.match(validCharRegex)) return new classes_1.ValidationResult(false);
  // Have double spaces on name string
  var noMatchDoubleSpaces = /^.*\s{2,}.*$/gi;
  if (nameWithoutSpaces.match(noMatchDoubleSpaces)) return new classes_1.ValidationResult(false);
  // Have any blacklisted word
  var blackListedNames = /^(dr|dra|sr|sra|eng)$/;
  if (fullNameArr.filter(function (word) {
    return word.toLowerCase().match(blackListedNames);
  }).length) return new classes_1.ValidationResult(false);
  // Custom properties
  // Have any word greater than max word length
  if ((properties === null || properties === void 0 ? void 0 : properties.maxWordLength) !== undefined) {
    var maxWordLength = properties.maxWordLength;
    if (fullNameArr.filter(function (word) {
      return word.length > maxWordLength;
    }).length) return new classes_1.ValidationResult(false);
  }
  // Valid name
  return new classes_1.ValidationResult(true);
}
exports.default = new classes_1.Validator(isValidName);